import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55dd2569"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-detail-page" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title ws_mb20" }, "基本信息", -1))
const _hoisted_5 = { class: "ws_mr15" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title ws_mb20" }, "设备配置", -1))
const _hoisted_8 = { class: "map-icon" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "btn ws_mt24" }

import { ref, computed, onMounted } from 'vue'
import MapModal from './components/map-modal.vue'
import SubDeviceForm from './components/sub-device-form-drawer.vue'
import {
  DEVICE_DATA_UPLOAD_ENUM,
  DEVICE_LOCATION_TYPE_ENUM,
  CODE_ENUM,
  PRODUCT_TYPE,
  MAP_ICON,
} from '@/common'
import {
  queryDeviceThingSubDeviceList,
  deviceInfoAdd,
  deviceInfoUpdate,
  queryDeviceInfo,
} from '@/api'
import { ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import { useProductStore } from '@/stores/product'
import { validateSubDevices, validateSubDevicesRequired } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {

const productStore = useProductStore()
productStore.queryGetewayType()

const router = useRouter()
const $route = useRoute()

const deviceBindId = $route.query.deviceBindId || ''

const iconList = [
  MAP_ICON.DEFAULT,
  MAP_ICON.CAR,
  MAP_ICON.SHIP,
  MAP_ICON.COW,
  MAP_ICON.FIRE,
  MAP_ICON.ANIMAL,
  MAP_ICON.PM25,
  MAP_ICON.PERSON,
  MAP_ICON.SLOPE,
]

const getClass = (i: any) => {
  const checked = i === formData.value.picCode
  const checkedClass = checked ? `${i}-C` : ''
  return `${i} ${checkedClass}`
}

const changePicCode = (picCode: any) => {
  formData.value.picCode = picCode
}

const devicelabelShow = computed(() => {
  return [PRODUCT_TYPE.SINGLE_GATEWAY].includes(productType.value)
})

onMounted(() => {
  if (deviceBindId) {
    queryDetail()
  }
})

const showSubDevice = computed(() => {
  return ![PRODUCT_TYPE.LORA, PRODUCT_TYPE.DIRECT_CONNECT].includes(
    productType.value
  )
})

const productType = computed(() => {
  return productStore.productGetewayType.filter(({ code }: any) => {
    return code === formData.value.productKey
  })?.[0]?.productType
})

const baseFormRef = ref()
const confFormRef = ref()

const formData = ref({
  deviceName: '',
  deviceSn: '',
  productKey: '',
  subDevices: [],
  locationTypeCode: DEVICE_LOCATION_TYPE_ENUM.AUTO,
  dataTypeCode: DEVICE_DATA_UPLOAD_ENUM.PROPERTIES,
  picCode: MAP_ICON.DEFAULT,
  deviceLabel: '',
})

const validatorLocation = (rule: any, value: any, callback: any) => {
  const { address, lng, lat } = mapData.value
  if (!address || !lng || !lat) {
    callback('请选择')
  } else {
    callback()
  }
}

const validateSubDevicesMethod = (rule: any, value: any, callback: any) => {
  if (!value) {
    callback()
    return
  } else {
    const flagList = formData.value.subDevices.map(
      (item: any, index: number) => {
        return validateSubDevices(
          index,
          formData.value.subDevices,
          productType.value
        )
      }
    )
    // 校验是否重复
    if (
      flagList.includes(true) ||
      validateSubDevicesRequired(formData.value.subDevices, productType.value)
    ) {
      callback('子设备信息有误，请进行核对')
    } else {
      callback()
    }
  }
}

const rules: any = {
  deviceName: { required: true, message: '请输入设备名称' },
  deviceSn: { required: true, message: '请输入设备SN' },
  productKey: { required: true, message: '请选择' },
  picCode: { required: true, message: '请选择' },
  // deviceLabel: [{ required: true, message: '请输入设备标签' }],
  subDevices: [
    // { required: true, type: 'array', message: '请选择' },
    { validator: validateSubDevicesMethod },
  ],
  address: {
    validator: validatorLocation,
  },
}

const validateForm = async (formRef: any) => {
  return new Promise((resolve: any) => {
    formRef.value.validate((valid: boolean) => {
      valid && resolve()
    })
  })
}

const loading = ref(false)
const submit = async () => {
  await Promise.all([validateForm(baseFormRef), validateForm(confFormRef)])

  let params: any = {
    deviceLabel: '',
  }
  if (formData.value.locationTypeCode === DEVICE_LOCATION_TYPE_ENUM.HAND) {
    const { address, lng, lat } = mapData.value
    params = {
      locationAddress: address,
      locationLong: lng,
      locationLat: lat,
    }
  }
  // 单模去掉多余字段  单模才有deviceLabel
  if (productType.value === PRODUCT_TYPE.SINGLE_GATEWAY) {
    const subDevices = formData.value.subDevices.map((item: any) => {
      return {
        ...item,
        busType: '',
        busId: '',
      }
    })
    params = {
      ...params,
      subDevices,
      deviceLabel: formData.value.deviceLabel || '',
    }
  } else if (
    [PRODUCT_TYPE.LORA, PRODUCT_TYPE.DIRECT_CONNECT].includes(productType.value)
  ) {
    params = {
      ...params,
      subDevices: [],
    }
  }
  loading.value = true
  const fn = deviceBindId ? deviceInfoUpdate : deviceInfoAdd
  const res: any = await fn({
    ...formData.value,
    ...params,
    deviceBindId,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg || '操作成功')
    setTimeout(() => {
      router.go(-1)
    }, 800)
  }
}

const mapData: any = ref({
  address: '',
  lng: '',
  lat: '',
})

const onMapChange = (mo: any) => {
  mapData.value = mo
  confFormRef.value.validateField('address')
}

// 切换所属产品 校验子设备
const productKeyChange = () => {
  if (formData.value.subDevices.length) {
    baseFormRef.value.validateField('subDevices')
  }
}

const mapConf = ref({
  visible: false,
})
const toShowMap = () => {
  mapConf.value.visible = true
}

const detailData: any = ref({})
const queryDetail = async () => {
  const res: any = await queryDeviceInfo({
    deviceBindId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const {
      deviceLocationInfo,
      locationTypeCode,
      deviceName,
      deviceSn,
      dataTypeCode,
      productKey,
      subDevices,
      picCode,
      deviceLabel,
    }: any = res.data || {}

    detailData.value = res.data

    if (locationTypeCode === DEVICE_LOCATION_TYPE_ENUM.HAND) {
      const { deviceAddress, latitude, longitude } = deviceLocationInfo || {}
      mapData.value = {
        address: deviceAddress,
        lng: longitude || '',
        lat: latitude || '',
      }
    }

    const subList = (subDevices || []).map(
      ({ productData, busType, busId, sensorId, deviceSnAlias }: any) => {
        const { productKey } = productData || {}
        return {
          productKey,
          busType: busType || '',
          busId: busId || '',
          sensorId,
          deviceSnAlias,
        }
      }
    )

    formData.value = {
      deviceName,
      deviceSn,
      locationTypeCode,
      dataTypeCode,
      productKey,
      subDevices: subList,
      picCode,
      deviceLabel,
    }
  }
}

const subDeviceConf = ref({
  visible: false,
  data: [],
})

const toHandSubDevice = () => {
  if (!productType.value) {
    ElMessage.warning('请先选择所属产品')
    return
  }
  subDeviceConf.value = {
    visible: true,
    data: formData.value.subDevices,
  }
}

const onSubDeviceChange = (subDevices: any) => {
  formData.value.subDevices = subDevices
  baseFormRef.value.validateField('subDevices')
}

const cancel = () => {
  router.go(-1)
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_el_form, {
            ref_key: "baseFormRef",
            ref: baseFormRef,
            class: "form-width",
            model: formData.value,
            "label-width": 80,
            "label-position": "left",
            rules: rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "设备名称",
                prop: "deviceName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.deviceName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.deviceName) = $event)),
                    placeholder: "请输入设备名称",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "productKey",
                label: "所属产品"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    disabled: !!detailData.value.productKey,
                    modelValue: formData.value.productKey,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.productKey) = $event)),
                    placeholder: "请选择产品类型",
                    class: "ws_select",
                    onChange: productKeyChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStore).productGetewayType, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.code,
                          label: item.name,
                          value: item.code
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "设备SN",
                prop: "deviceSn"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.deviceSn,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.deviceSn) = $event)),
                    disabled: !!_unref(deviceBindId),
                    placeholder: "请输入设备SN",
                    clearable: ""
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              (showSubDevice.value)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "子设备",
                    prop: "subDevices"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_5, "已关联" + _toDisplayString(formData.value.subDevices.length) + "个子设备", 1),
                      _createVNode(_component_el_button, {
                        plain: "",
                        onClick: toHandSubDevice
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("关联子设备")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (devicelabelShow.value)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "设备标签",
                    prop: "deviceLabel"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.deviceLabel,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.deviceLabel) = $event)),
                        disabled: !!detailData.value.deviceLabel,
                        clearable: "",
                        maxLength: "20"
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_form, {
            ref_key: "confFormRef",
            ref: confFormRef,
            model: formData.value,
            "label-width": 85,
            "label-position": "left",
            "hide-required-asterisk": "",
            rules: rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "数据上传" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: formData.value.dataTypeCode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.dataTypeCode) = $event)),
                    prop: "dataTypeCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        label: _unref(DEVICE_DATA_UPLOAD_ENUM).PROPERTIES,
                        class: "radio-align"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("变量模板 ")
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_radio, {
                        label: _unref(DEVICE_DATA_UPLOAD_ENUM).UNRESOLVED
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("透传")
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "设备定位" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: formData.value.locationTypeCode,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.locationTypeCode) = $event)),
                    prop: "locationTypeCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        label: _unref(DEVICE_LOCATION_TYPE_ENUM).AUTO,
                        class: "radio-align"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("自动定位 ")
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_radio, {
                        label: _unref(DEVICE_LOCATION_TYPE_ENUM).HAND
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("手动定位")
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "设备图标",
                prop: "picCode"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(iconList, (i) => {
                      return _createElementVNode("i", {
                        class: _normalizeClass(getClass(i)),
                        key: i,
                        onClick: ($event: any) => (changePicCode(i))
                      }, null, 10, _hoisted_9)
                    }), 64))
                  ])
                ]),
                _: 1
              }),
              (formData.value.locationTypeCode === _unref(DEVICE_LOCATION_TYPE_ENUM).HAND)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "设备地图",
                    error: "",
                    prop: "address"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(mapData.value.address), 1),
                      _createVNode(_component_el_button, {
                        onClick: toShowMap,
                        class: "search"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("地图")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_button, {
            onClick: submit,
            loading: loading.value,
            class: "ws_mr16",
            size: "large",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, {
            onClick: cancel,
            size: "large",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(MapModal, {
      visible: mapConf.value.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((mapConf.value.visible) = $event)),
      data: mapData.value,
      onOnMapChange: onMapChange
    }, null, 8, ["visible", "data"]),
    _createVNode(SubDeviceForm, {
      visible: subDeviceConf.value.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((subDeviceConf.value.visible) = $event)),
      data: subDeviceConf.value.data,
      productType: productType.value,
      onOnChange: onSubDeviceChange
    }, null, 8, ["visible", "data", "productType"])
  ], 64))
}
}

})